import React, { useState, useEffect, useRef } from "react";
import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs";
import { UrlPath } from "../../../config/routeConfig";
import { TopBar } from "../../shared/topBar/TopBar";
import { useNavigate, useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { SBADropDown, SBAComboBox } from "../../UiComponents/SBADropDown";
import { getPortFolioListAction, getPortFolioCashAccountAction } from "../../actions/portfolioAction";
import { getTransactionStatusAction} from "../../actions/transactionAction";
import { sbaAxios } from "../../utils/sbaAxios";
import { SBDatePicker } from "../../UiComponents/SBDatePicker";
import { SBNotify } from "../../utils/sbNotify";
import { ToastContainer } from "react-toastify";
import moment from "moment";
import { getPortfolioValuationByAssetLot,assetDetailsUrl,insertUpdateRedemption, getTransactionAssetsByType, getPortfolioDetailAPI, getexistingshareclass, getPortfolioListAPI} from "../../../config/apiConfig"
import { getAssestListddlAction } from '../../actions/assetsddlAction';
import { getAsset} from "../../actions/assetAction";
import { getShareClassbyAssetId } from "../../actions/assetShareClassAction";
import { currencyFormatter, getTransactionByID ,getPortfolioListByAssetAndTransType,gettransactionEditAccess} from "../utils";
import { SBACurrencyInput } from "../../UiComponents/SBACurrencyInput";
import { Link } from "react-router-dom";
import { ExchangeRateModal } from "../Components/ExchangeRateModal";
import $ from 'jquery';
export const Distribution = () => {

    const history = useNavigate();
    const params = useParams();
    const transactionId = parseInt(params.TransId) || 0;
    const objType = parseInt(params?.ObjectType);
    const [transactionData, setTransactionData] = useState(plainDistribution);
    const[transactionEditAccess,setTransactionEditAccess]=useState(false);
    const dispatch = useDispatch();
    const Gstate = useSelector((state) => state);

    const Level = objType == 1 ? [
        {
            BreadCrumb: "Transactions >",
            Routes: `${UrlPath.Transactions}${params.AssetId}`,
        },
        {
            BreadCrumb: "Distribution",
            Routes: `${UrlPath.Distribution}${params.AssetId}`,
        },
    ] : [
        {
            BreadCrumb: "Transactions >",
            Routes: `/${UrlPath.portfolioTransaction}${params.EntityId}`,
        },
        {
            BreadCrumb: "Distribution",
            Routes: `/${UrlPath.PortfolioDistribution}${params.EntityId}`,
        },
    ];
    
    useEffect(() => {
        document.title = "Transactions Distribution";

    }, []);

   
    const statusStore = Gstate.transaction.statusList || [];
    const [portfolioList, setPortfolioList] = useState([]);
    const ToAccount = Gstate.portfolio.TOCash || [];
    const iseditable = transactionId === 0 ? false : true;
    const [portfolio, setPortfolio] = useState();
    const [assetList, setAssetList] = useState([]);
  const [shareClassList, setShareClassList] = useState([]);
    const [IsFIFO, setIsFIFO] = useState(true);
    const [showModal, setShowModal] = useState(false);

    const [grid, setGrid] = useState([]);
    const [statusDS, setStatusDS] = useState(statusStore);
   
    const portfolioVal = { "PortfolioId": transactionData.PortfolioId, "PortfolioName": transactionData.PortfolioName }
    const statusVal = { "TransStatus": transactionData.TradeStatusName, "TransStatusId": transactionData.TradeStatusId };
    const ShareClassVal = { "ShareClassId": transactionData.ShareclassId, "ShareClassName": transactionData.ShareClassName }
    const AssetVal = { "AssetId": transactionData.AssetId, "AssetName": transactionData.AssetName }
    const ToAccountsVal = { "AssetId": transactionData.AccountIdToBalance, "AssetName": transactionData.AccountIdToBalanceName }
    const InterestExpense = transactionData.TransactionPEDetails.InterestExpense ? transactionData.TransactionPEDetails.InterestExpense : "0.00";
    const InterestIncome = transactionData.TransactionPEDetails.InterestIncome ? transactionData.TransactionPEDetails.InterestIncome : "0.00";
    const Recallablepercent = transactionData.TransactionPEDetails.RecallablePercent ? transactionData.TransactionPEDetails.RecallablePercent : "0.00";
    const RecallableAmount = transactionData.TransactionPEDetails.RecallableAmount ? transactionData.TransactionPEDetails.RecallableAmount : "0.00";


    useEffect(() => {

        setTransactionEditUserAccess();
        dispatch(getTransactionStatusAction());
        dispatch(getAssestListddlAction());
        dispatch(getAsset(params.EntityId));
       // dispatch(getShareClassbyAssetId(params.EntityId,transactionData.PortfolioId));
       
        if (objType == 1) {
            setAssetByID(params?.EntityId);
            if(transactionId===0)
            {
            setPortfolioByAssetId(params?.EntityId,transactionData.PortfolioId);
            
            }
           
          }
          else if (objType == 3) {
       
        setPortfolioByID(params?.EntityId);
        if(transactionData===0)
       setShareClassListbyAssetID(transactionData.AssetId,params?.EntityId);
       dispatch(getPortFolioCashAccountAction(params?.EntityId));
          }
     
        setTransactionByID(transactionId);
    }, []);

    useEffect(() => {
        setStatusDS(statusStore)
        setTransactionData(value => ({ ...value, Status: statusStore[2] }));
    }, [statusStore]);


    // useEffect(()=>{
      
    // }, [transactionData.PortfolioId, transactionData.AssetId]);

    // useEffect(() => {
    //     if (transactionData.AssetId > 0) {
    //         setShareClassListbyAssetID(transactionData.AssetId);
    //     }
    // }, [transactionData.AssetId]);


 // User Access Rights
 const setTransactionEditUserAccess= async()=>
 {
     const access = await gettransactionEditAccess();
     setTransactionEditAccess(access);
 }


    const setAssetByID = async (Id) => {
        try {
          const asset = await getAssetByID(Id);
          setTransactionData(value => ({ ...value, AssetName: asset?.AssetName, AssetId: asset?.AssetId }));
        }
        catch (e) {
          setTransactionData(value => ({ ...value, AssetId: 0, AssetName: '' }));
          setPortfolio({});
        }
      }
      const getAssetByID = async (AssetID) => {
        try {
          const response = await sbaAxios({ url: assetDetailsUrl + AssetID });
          return response;
        }
        catch (e) {
          console.log(e, 'Error Fetching the Asset details')
          return {};
        };
      };
      const setPortfolioByAssetId = async (Id) => {
      
        try {
          const portfolio = await getPortfolioListByAssetAndTransType(Id,25);
        const  portfolios= portfolio.map((item) => ({
            'PortfolioName':item.Name,
            'PortfolioId':item.PortfolioId
        }))
          setPortfolioList([]);
          if(portfolios.length>0)
          {
          setTransactionData(value => ({ ...value, "PortfolioName": portfolios[0]?.PortfolioName, "PortfolioId": portfolios[0]?.PortfolioId }));
          setPortfolioByID(portfolios[0]?.PortfolioId);
          setShareClassListbyAssetID(params.EntityId,portfolios[0]?.PortfolioId);
          dispatch(getPortFolioCashAccountAction(portfolios[0]?.PortfolioId));
          }
        }
        catch (e) {
          setTransactionData(value => ({ ...value, PortfolioId: 0, PortfolioName: '' }));
          setPortfolioList([]);
        }
      }
 
    const getValuationByAssetLot = async (portfolioId, assetid, shareClassid, transactionDate, transDetails) => {
        let formattedDate = moment(transactionDate).format('MM/DD/YYYY');
        try {
            const initialChild = {
                "AssetLotName": "",
                "AssetLotId": 0,
                "AssetId": 0,
                "TransId":0,
                "TransTypeId": 22,
                "TransactionDate":"",
                "InitialAllocationDate": "",
                "TransAmount": 0,
                "TransPercentage":0,
                "TransPosition": 0,
                "TotalPosition":0,
                "NrOfShares": 0,
                "SharestoRedeem": 0,
                "RowIndex": 0,
            }
            const response = await sbaAxios({
                url: getPortfolioValuationByAssetLot,
                params:{
                    portfolioId: portfolioId,
                    assetId: assetid,
                    shareClassId: shareClassid,
                    transactionDate: formattedDate
                },
                method: 'get',
            });
            if (response) {
               
                const lotsdata = response.Lots;
                if (transactionId == 0) {
                    setTransactionData((prevData) => ({

                        ...prevData,
                        ExchangeRate: response.ExchangeRate,

                        TransPercentage: response.PercentOfPosition,
                        TransAmount: response.TotalPosition,
                        LocalAmount: response.TotalPosition * response.ExchangeRate,
                        DistTotalPosition: response.TotalPosition,
                        DistTotalTransAmt: response.TotalPosition,
                        DistTotalTransPercent: response.PercentOfPosition,
                        LocalLoadFees:initialChild?.TransAmount*prevData.ExchangeRate,
                        TotalDistributionAmount:(parseFloat(response.TotalPosition))-(parseFloat(initialChild?.TransAmount)),
                        TotalLocalAmount:parseFloat(response.TotalPosition * response.ExchangeRate)-parseFloat(initialChild?.TransAmount*prevData.ExchangeRate),
                          ChildDetails: [initialChild, ...lotsdata.map((row, rowIndex) => ({
                              "AssetLotName": row.AssetLotName,
                              "AssetLotId": row.AssetLotId,
                              "AssetId": transactionData.AssetId,
                              "TransTypeId": transactionData.AccountIdToBalance===3?26:25,
                              "TransId":0,
                              "TransactionDate": transactionDate.TransDate,
                              "InitialAllocationDate": row.InitialAllocationDate,
                              "TransAmount": row.AmountToRedeem,
                              "TransPercentage": row.PercentToRedeem,
                              "TransPosition": row.Position,
                              "TotalPosition": row.Position,
                              "RowIndex": rowIndex,

                          }))]


                    }))


                    
                }
                else { 
                    const editchilditems= transDetails.ChildDetails.filter(item => item.AssetId !== transDetails.AccountIdToBalance && (item.TransTypeId===26||item.TransTypeId===25));
                    const edititems=transDetails.ChildDetails.filter(item => item.AssetId === transDetails.AccountIdToBalance || item.TransTypeId===22);
                    const editLoadfees=transDetails.ChildDetails.filter(item =>item.TransTypeId===22);  
                    const editchild=   editchilditems.map((row, rowIndex) => ({
                        ...row,
                         "TransPosition": lotsdata[rowIndex]?.Position,
                         "InitialAllocationDate": lotsdata[rowIndex]?.InitialAllocationDate
                    }))
                    const loadfees=Math.abs(editLoadfees[0]?.TransAmount||0)*transDetails.ExchangeRate;
                    const totlocalamt=parseFloat(Math.abs(transDetails.LocalAmount)) - parseFloat(loadfees);
                        const items = [...editchild, ...edititems];
            
                        if (!items.some(item => item.TransTypeId === 22)) {
                            items.push(initialChild);
                        }
                        const editselectedchild= items.map((row, rowIndex) => ({
                               
                            ...row,
                         
                             "RowIndex": rowIndex
                              
                          }))
                          setTransactionData((prevData) => ({
    
                            ...prevData,
                             ShareclassId:transDetails.ShareclassId,
                             ShareClassName:transDetails.ShareClassName,
                            DistTotalPosition:response.TotalPosition,
                           DistTotalTransPercent:Math.abs(prevData.TransPercentage),
                           DistTotalTransAmt:Math.abs(prevData.TransAmount),
                           LocalLoadFees:loadfees,
                           TotalDistributionAmount:(parseFloat(Math.abs(transDetails.TransAmount)))-(parseFloat(Math.abs(editLoadfees[0]?.TransAmount||0))),
                           TotalLocalAmount:totlocalamt,
                            ChildDetails:editselectedchild
                        }))
               
                }
            }
           

        }
        catch (e) {
            return [];
        };
    };

    // Shareclass By AssetID

    const setShareClassListbyAssetID = async (id,pId) => {
        try {
            const res = await getshareclassbyId(id,pId);
            setShareClassList(res);
          
            if (res.length > 0) {
                setTransactionData((prevData) => ({ ...prevData, ShareclassId: res[0].ShareClassId, ShareClassName: res[0].ShareClassName }));
                getValuationByAssetLot(pId, id, res[0].ShareClassId, transactionData.TransDate);
            }
            else {
                setTransactionData(value => ({ ...value, ShareclassId: 0, ShareClassName: '' }));
                getValuationByAssetLot(pId, id, 0, transactionData.TransDate);
            }

        }
        catch (e) {
            setShareClassList([]);
            setTransactionData(value => ({ ...value, ShareclassId: 0, ShareClassName: '' }));
        }
    };
    const getshareclassbyId = async (AssetId,pId) => {
        try {
            const response = await sbaAxios({
                url: `${getexistingshareclass}${pId},${AssetId}`,
                method: 'get',
            });
            // if (response.length > 0) {
            //     setTransactionData((prevData) => ({ ...prevData, ShareclassId: response[0].ShareClassId, ShareClassName: response[0].ShareClassName }));
            // }
            // else {
            //     setTransactionData(value => ({ ...value, ShareclassId: 0, ShareClassName: '' }));
            // }

            return response;
        }
        catch (e) {
            return [];
        };
    };


    //Asset by term
    const setAssetListByTerms = async (term) => {
        try {
            const assetList = await getAssetListByTerm(term);
            setAssetList(assetList);
        }
        catch (e) {
            console.log(e, 'Error Fetching the asset List');
            setAssetList([]);
        }
    }
    const getAssetListByTerm = async (term) => {
        try {
            const resposne = await sbaAxios({ url: `${getTransactionAssetsByType}?transTypeId=25&searchString=${term}` })
            return resposne;
        }
        catch (e) {
            return []
        };
    };

    //set portfolio data

    const setPortfolioByID = async (Id) => {

        try {
            const portfolio = await getPortfolioDetailsByID(Id);
            setTransactionData(value => ({ ...value, PortfolioId: portfolio?.PortfolioId, PortfolioName: portfolio?.PortfolioName }));
            setPortfolio(portfolio);
        }
        catch (e) {
            setTransactionData(value => ({ ...value, PortfolioId: 0, PortfolioName: '' }));
            setPortfolio({});
        }

    };
    // Get Transcation Details
    const setTransactionByID = async (id) => {
        if (id > 0) {
            try {
                const details = await getTransactionByID(id);
            
                setTransactionData({...details,TransPercentage:Math.abs(details.TransPercentage)});
                setPortfolioByID(details.PortfolioId);
                getValuationByAssetLot(details.PortfolioId, details.AssetId, details.ShareclassId,details.TransDate,details)
              
                dispatch(getPortFolioCashAccountAction(details.PortfolioId));
       
              
            } catch (e) {
                setTransactionData(plainDistribution);
            }
        }
        else {
            setTransactionData(plainDistribution);
        }

    };
    //Onchange controls 

    const portfolioDDChng = (e) => {
      
        if (e.value) {
           
            setPortfolioByID(e.value.PortfolioId);
            dispatch(getPortFolioCashAccountAction(e.value.PortfolioId));
            if (objType === 3) {
            setTransactionData(value => ({ ...value, AssetId: 0, AssetName: '', ShareclassId: 0, ShareClassName: '' }));           
            setShareClassListbyAssetID(transactionData.AssetId,e.value.PortfolioId);
            history(`/${UrlPath.PortfolioDistribution}${transactionId}/${e.value.PortfolioId}/3`);
            
        }
            else{
               
                setShareClassListbyAssetID(transactionData.AssetId,e.value.PortfolioId);
                setTransactionData(value => ({ ...value, PortfolioName: e.value.PortfolioName, PortfolioId: e.value.PortfolioId}));
            }
        }
    };
    const statusDDChng = (e) => {

        if (e.value) {
            setTransactionData(value => ({ ...value, TradeStatusId: e.value.TransStatusId, TradeStatusName: e.value.TransStatus }));
        }
    };
    const AssetChng = (e) => {

        if (e.value) {
            const asset = e.value;
            if (objType === 1) {
                setPortfolioByAssetId(e.value.AssetId);
               
                history(`${UrlPath.Distribution}${transactionId}/${e.value.AssetId}/1`);
            }
            setShareClassListbyAssetID(e.value.AssetId,transactionData.PortfolioId);
            setAssetByID(e.value.AssetId);
            setTransactionData(pv => ({ ...pv, AssetId: asset.AssetId, AssetName: asset.AssetName, ShareclassId: 0, ShareClassName: '', AssetLotId: 0, AssetLotName: '' }));
         
        }
    };
    const ToaccountChange = (e) => {


        setTransactionData((prevData) => ({
            ...prevData,
            AccountIdToBalance: e.value.AssetId, 
            AccountIdToBalanceName: e.value.AssetName,
            ChildDetails: prevData.ChildDetails.map((row) => 
                row.AssetId !== prevData.AssetId
                    ? {
                        ...row,
                        AssetId: e.value.AssetId,
                        AssetName: e.value.AssetName
                      }
                    : row
            )
        }));
        
       

    }

    const ShareClassChng = (e) => {
        if (e.value) {
            const shareClass = e.value;
            setTransactionData(pv => ({ ...pv, ShareclassId: shareClass.ShareClassId, ShareClassName: shareClass.ShareClassName, AssetLotId: 0, AssetLotName: '' }));
            getValuationByAssetLot(transactionData.PortfolioId, transactionData.AssetId, e.value.ShareClassId, transactionData.TransDate.toISOString());


        }
    };
    const transdateChange = (e) => {

        setTransactionData((prevData) => ({ ...prevData, ["TransDate"]: moment(e).format("MM-DD-yyyy") }));
        getValuationByAssetLot(transactionData.PortfolioId, transactionData.AssetId, transactionData.ShareclassId, moment(e).format("MM-DD-yyyy"));

    }
    // Asset Fillterchange
    const AssetFilterChange = (e) => {
        const terms = e.filter.value;
        if (terms.length > 1) {
            setAssetListByTerms(terms);
        }
    };
    const navigateBack = () => {
        if (objType === 1)
            history(`${UrlPath.Transactions}${params.EntityId}`);
        if (objType === 3)
            history(`/${UrlPath.portfolioTransaction}${transactionData.PortfolioId}`);
    };
    const FIFOChange = (e) => {

        setIsFIFO(e.target.checked);
        setTransactionData((prevData) => ({

            ...prevData,

            ChildDetails: [...prevData.ChildDetails.map((row, rowIndex) => ({
                ...row,
                "RedeemAllShares": e.target.checked
            }))]

        }))
    }
    // Calculation Part 
    const percentToamountCalc = (e) => {
        const Loadfees=transactionData.ChildDetails.filter(item =>item.TransTypeId===22);  
        const parsedPercentage = e.target.value || 0;
      const parsedValue = parsedPercentage > 100 ? 100 : parsedPercentage;

      let Distrtotal=0;
        setTransactionData(prevState => {
            Distrtotal=((parsedValue / 100) * prevState.DistTotalPosition)-Math.abs(Loadfees[0].TransAmount);
            return {
                ...prevState,
                TransAmount: ((parsedValue / 100) * prevState.DistTotalPosition).toFixed(2),
                TransPercentage: parseFloat(parsedValue) ,
              
                // DistTotalTransAmt: TransAmountTotal,
                // DistTotalTransPercent: TransPercentageTotal.toFixed(2),
                LocalAmount: (((parsedValue / 100) * prevState.DistTotalPosition) * prevState.ExchangeRate),
                TotalDistributionAmount:((parsedValue / 100) * prevState.DistTotalPosition)-Math.abs(Loadfees[0].TransAmount),
                TotalLocalAmount:(((parsedValue / 100) * prevState.DistTotalPosition) * prevState.ExchangeRate)-prevState.LocalLoadFees

            };
          
        });
        if(IsFIFO)
        Calculategridvalue(Distrtotal, IsFIFO, false);
    }
    const Calculategridvalue = (Sum, isFIFO, isPercent) => {
        if ((Sum != null) && (Sum > 0)) {
            var rows = transactionData.ChildDetails;
            for (var i = 0; i < rows.length; i++) {
                var hflot = rows[i].AssetLotId;
                var hfPosition = rows[i].TransPosition;
                var inpPercent = rows[i].TransPercentage;
                var inpBalance = rows[i].TransAmount;
                var rowindex = rows[i].RowIndex;
                if ((hflot != null) && (hfPosition != null)) {
                    var position = rows[i].TransPosition;
                    if (inpPercent == null)
                        inpPercent = 0
                    if (inpBalance == null)
                        inpBalance = 0
                    var tbPercent = inpPercent;
                    var tbBalance = inpBalance;
                    if (position <= 0)
                        continue;
                    if ((!isPercent) && (isFIFO)) {
                        var valueToSet = 0;
                        if (i == rows.length - 1) {
                            valueToSet = Sum;

                        }
                        else {
                            valueToSet = Sum > position ? position : Sum;

                        }
                        if (valueToSet.toString().indexOf("e") != -1) {
                            valueToSet = valueToSet.toFixed(12);
                        }
                        if (valueToSet == 0) {
                            rows[i].TransAmount = "";
                            rows[i].TransPercentage = "";
                            $(("#txt_DistAmount_" + (rowindex))).val(0);
                            $(("#txt_DistPercent_" + (rowindex))).val('');
                        }
                        else {
                            rows[i].TransAmount = valueToSet;
                            setTransactionData((prevData) => ({
                                ...prevData,
                                ChildDetails: prevData.ChildDetails.map((item, index) => {
                                    if (index === i) {
                                        return { ...item, TransAmount: valueToSet };
                                    }
                                    return item;
                                })
                            }));

                            Sum -= valueToSet;

                            valueToSet = ((valueToSet / position) * 100);
                            if (valueToSet == 0) {
                                rows[i].TransPercentage = "";
                                setTransactionData((prevData) => ({
                                    ...prevData,
                                    ChildDetails: prevData.ChildDetails.map((item, index) => {
                                        if (index === i) {
                                            return { ...item, TransPercentage: "" };
                                        }
                                        return item;
                                    })
                                }));
                            }
                            else {
                                rows[i].TransPercentage = valueToSet;
                                if (valueToSet != 100) {
                                    setTransactionData((prevData) => ({
                                        ...prevData,
                                        ChildDetails: prevData.ChildDetails.map((item, index) => {
                                            if (index === i) {
                                                return { ...item, TransPercentage: valueToSet };
                                            }
                                            return item;
                                        })
                                    }));
                                }
                                else {
                                    setTransactionData((prevData) => ({
                                        ...prevData,
                                        ChildDetails: prevData.ChildDetails.map((item, index) => {
                                            if (index === i) {
                                                return { ...item, TransPercentage: valueToSet };
                                            }
                                            return item;
                                        })
                                    }));
                                }
                            }
                        }
                    }
                    else if (isPercent) {
                        var valueToSet = (Sum / 100) * position;
                        if (valueToSet == 0) {
                            rows[i].TransAmount = "";
                            $(("#txt_DistAmount_" + (rowindex))).val(0);
                        }
                        else {
                            rows[i].TransAmount = valueToSet;
                            $(("#txt_DistAmount_" + (rowindex))).val(valueToSet);
                        }
                        if (Sum == 0) {
                            rows[i].TransPercentage = "";
                            $(("#txt_DistPercent_" + (rowindex))).val('');
                        }
                        else {
                            rows[i].TransPercentage = Sum;
                            $(("#txt_DistPercent_" + (rowindex))).val(Sum.toFixed(0));
                        }
                    }

                }
            }

            setTransactionData((prevData) => ({ ...prevData, DistTotalTransPercent: prevData.TransPercentage, DistTotalTransAmt: parseFloat(prevData.TransAmount) }));
        }
    }
   
    const GridpercentToamountCalc = (e, RowIndex) => {
        const Loadfees=transactionData.ChildDetails.filter(item =>item.TransTypeId===22);
        const parsedPercentage = parseFloat(e) || 0;
        const parsedValue = parsedPercentage > 100 ? 100 : parsedPercentage;
        var rows = transactionData.ChildDetails;
            for (var i = 0; i < rows.length; i++) {
                if((rows[i].TransTypeId === 25 && rows[i].AssetId!==transactionData.AccountIdToBalance) || (rows[i].TransTypeId ===26 && rows[i].AssetId!==transactionData.AccountIdToBalance))
                {
            if (parseInt(rows[i].RowIndex) == RowIndex) {
                var percent=$("#txt_DistPercent_" + RowIndex+"").val();
                var percentredeem = parseFloat(percent)>100?100:percent;
               
                var posredeem =rows[i].TransPosition;
                var TotalBalance = (percentredeem / 100) * posredeem;
                $("#txt_DistAmount_" + RowIndex + "").val(TotalBalance);
                setTransactionData((prevData) => ({
                    ...prevData,
                    ChildDetails: prevData.ChildDetails.map((item, index) => {
                        if((item.TransTypeId === 25 && item.AssetId!==transactionData.AccountIdToBalance) || (item.TransTypeId ===26 && item.AssetId!==transactionData.AccountIdToBalance))
                        {
                        if (index === i) {
                            return { ...item, TransAmount: TotalBalance,TransPercentage: percentredeem  };
                        }
                    }
                        return item;
                    })
                }));

          
            }
          
          
            }
        }
        var calculated_total_sum = 0;
        $("#DistributionTable .Distamt").each(function () {
            var get_textbox_value = $(this).val().replace(/,/g, '');
            if (get_textbox_value !="")
                calculated_total_sum += parseFloat(get_textbox_value);
        });
        $("#txtTransAmount").text(calculated_total_sum.toLocaleString());
        var posval = $("#txtTransAmtTotalPosition").text().replace(/,/g, '');
        var AmtDist = $("#txtTransAmount").text().replace(/,/g, '');
        var TotalPercentToRedeem = AmtDist * 100 / posval;

        $("#txtTransPercTotalPosition").text(TotalPercentToRedeem.toFixed(2));
        setTransactionData((prevData) => ({ ...prevData, TransAmount: calculated_total_sum,TransPercentage:TotalPercentToRedeem,DistTotalTransPercent: TotalPercentToRedeem, DistTotalTransAmt: parseFloat(calculated_total_sum),
            LocalAmount: (calculated_total_sum * prevData.ExchangeRate),
            TotalDistributionAmount:(calculated_total_sum)-Math.abs(Loadfees[0].TransAmount),
            TotalLocalAmount:(calculated_total_sum * prevData.ExchangeRate)-prevData.LocalLoadFees

        }));


    }
    const TopercentCalc = (e) =>
    {  
        const Loadfees=transactionData.ChildDetails.filter(item =>item.TransTypeId===22);   
        const parsedValue = parseFloat(e) || 0;
        let Distrtotal=0;

        setTransactionData(prevState => {
            const percent=((parsedValue / prevState.DistTotalPosition) * 100)
            Distrtotal=((percent / 100) * prevState.DistTotalPosition)-Math.abs(Loadfees[0].TransAmount);

            return {
                ...prevState,
                TransAmount: parsedValue,
                TransPercentage: ((parsedValue / prevState.DistTotalPosition) * 100).toFixed(2),
             //   ChildDetails: updatedChildDetails,
                // DistTotalTransAmt: TransAmountTotal,
                // DistTotalTransPercent: TransPercentageTotal.toFixed(2),
                LocalAmount: (parsedValue * prevState.ExchangeRate),
                TotalDistributionAmount:parsedValue-Math.abs(Loadfees[0].TransAmount||0),
                TotalLocalAmount:(parsedValue * prevState.ExchangeRate)-Math.abs(prevState.LocalLoadFees)
            };
        });

        if(IsFIFO)
        Calculategridvalue(Distrtotal, IsFIFO, false);

    }
    const GridTopercentCalc = (e, RowIndex) => {
        const Loadfees=transactionData.ChildDetails.filter(item =>item.TransTypeId===22);
       const amt= parseFloat(e)||0;
       
        if (amt != null && amt != "") {
            setTransactionData((prevData) => ({
                ...prevData,
                ChildDetails: prevData.ChildDetails.map((item, index) => {
                    if((item.TransTypeId === 25 && item.AssetId!==transactionData.AccountIdToBalance) || (item.TransTypeId ===26 && item.AssetId!==transactionData.AccountIdToBalance))
                    {
                    if (item.RowIndex === RowIndex) {
                       const  parsedValue = amt>item.TransPosition?item.TransPosition:amt;
                        return { ...item, TransAmount: parsedValue };
                    }
                }
                    return item;
                })
            }));
        }
        if (amt == "") {
            setTransactionData((prevData) => ({
                ...prevData,
                ChildDetails: prevData.ChildDetails.map((item, index) => {
                    if((item.TransTypeId === 25 && item.AssetId!==transactionData.AccountIdToBalance) || (item.TransTypeId ===26 && item.AssetId!==transactionData.AccountIdToBalance))
                    {
                    if (item.RowIndex === RowIndex) {
                        return { ...item, TransAmount: 0 };
                    }
                }
                    return item;
                })
            }));
        }
       
        var rows = transactionData.ChildDetails;

        for (var i = 0; i < rows.length; i++) {
            if((rows[i].TransTypeId === 25 && rows[i].AssetId!==transactionData.AccountIdToBalance) || (rows[i].TransTypeId ===26 && rows[i].AssetId!==transactionData.AccountIdToBalance))
                {
            if (rows[i].RowIndex === RowIndex) {
                var distamt = $("#txt_DistAmount_" + RowIndex + "").val().replace(/,/g, '');
               
                var posredeem = rows[i].TransPosition;
                var damt=distamt>posredeem?posredeem:distamt
                var percentdisamt = (damt / posredeem) * 100;
                $("#txt_DistPercent_" + RowIndex + "").val(percentdisamt.toFixed(2)); 
                setTransactionData((prevData) => ({
                    ...prevData,
                    ChildDetails: prevData.ChildDetails.map((item, index) => {
                        if (item.RowIndex === RowIndex) {
                            return { ...item, TransPercentage: percentdisamt };
                        }
                        return item;
                    })
                }));
                
        }
    }
}
        var calculated_total_sum = 0;
        $("#DistributionTable .Distamt").each(function () {
            var get_textbox_value = $(this).val().replace(/,/g, '');
            if (get_textbox_value != "")
                calculated_total_sum += parseFloat(get_textbox_value);
        });
        $("#txtTransAmount").text(calculated_total_sum.toLocaleString());
        var posval = $("#txtTransAmtTotalPosition").text().replace(/,/g, '');
        var AmtDist = $("#txtTransAmount").text().replace(/,/g, '');
        $("#txtTransPercTotalPosition").text(parseFloat(percentdisamt).toFixed(2));
    

        setTransactionData((prevData) => ({ ...prevData, TransAmount: calculated_total_sum,TransPercentage:percentdisamt,DistTotalTransPercent: percentdisamt, DistTotalTransAmt: parseFloat(calculated_total_sum),
            LocalAmount: (calculated_total_sum * prevData.ExchangeRate),
            TotalDistributionAmount:(calculated_total_sum)-Math.abs(Loadfees[0].TransAmount),
            TotalLocalAmount:(calculated_total_sum * prevData.ExchangeRate)-prevData.LocalLoadFees

        }));

    };


    

    const saveDistribution = () => {
        let saveSuccess = true;
        const childtrans =transactionId==0?  transactionData.ChildDetails.map((item, parentIndex) => (
            item.TransTypeId == 22 && item.TransAmount!=0?
            {
                "TransId": item.TransId,
                "AssetId": transactionData.AssetId,
                "AssetLotId": item.AssetLotId,
                "TransTypeId": 22,
                "transDate": transactionData.TransDate,
                "transAmount": -(item.TransAmount),
                "localAmount": -(item.TransAmount * transactionData.ExchangeRate),
                "transDescription": transactionData.TransDescription,
                "TransPercentage": null,
                "Shares": null,
            } :
         item.TransTypeId === 26|| item.TransTypeId===25? 
                   {
                    "TransId": item.TransId,
                    "AssetId": transactionData.AssetId,
                    "AssetLotId": item.AssetLotId,
                    "TransTypeId": transactionData.AccountIdToBalance===3?26:25,
                    "transDate": transactionData.TransDate,
                    "transAmount": -(item.TransAmount),
                    "localAmount": -(item.TransAmount * transactionData.ExchangeRate),
                    "transDescription": transactionData.TransDescription,
                    "TransPercentage": item.TransPercentage,
                    "Shares": null,
                }: null

                )).filter(item => item !== null)
                : transactionData.ChildDetails.map((item, parentIndex) => (
                    item.TransTypeId === 22 ?
                           {
                               "TransId": item.TransId,
                               "AssetId": transactionData.AssetId,
                               "AssetLotId": item.AssetLotId,
                               "TransTypeId": 22,
                               "transDate": transactionData.TransDate,
                               "transAmount": -(item.TransAmount),
                               "localAmount": -(item.TransAmount * transactionData.ExchangeRate),
                               "transDescription": transactionData.TransDescription,
                               "TransPercentage": null,
                               "Shares": null,
                           } : item.TransTypeId === 25 || item.TransTypeId === 26 ? {
                               "TransId": transactionId==0?0:item.TransId,
                               "AssetId": transactionId==0?transactionData.AssetId:item.AssetId,
                               "AssetLotId": item.AssetLotId,
                               "TransTypeId": transactionData.AccountIdToBalance===3?26:25,
                               "transDate": transactionData.TransDate,
                               "transAmount": -(item.TransAmount),
                               "localAmount": -(item.TransAmount * transactionData.ExchangeRate),
                               "transDescription": transactionData.TransDescription,
                               "TransPercentage": item.TransPercentage,
                               "Shares": null,
                           }: null

                )).filter(item => item !== null)
                         
       const peData=  {
            "PETransDetailID": 0,
            "IsRecallable": transactionData.TransactionPEDetails.IsRecallable,
            "IsImpactCommitment": transactionData.TransactionPEDetails.IsImpactCommitment,
            "RecallableAmount": transactionData.TransactionPEDetails.RecallableAmount,
            "RecallablePercent": transactionData.TransactionPEDetails.RecallablePercent,
            "InterestIncome": transactionData.TransactionPEDetails.InterestIncome,
            "InterestExpense": transactionData.TransactionPEDetails.InterestExpense,
        }
        const savedata = {

            "transId": transactionId,
            "portfolioId": transactionData.PortfolioId,
            "assetId": transactionData.AssetId,
            "shareClassId": transactionData.ShareclassId,
            "assetLotId": 0,
            "accountIdToBalance": transactionData.AccountIdToBalance,
            "tradeStatusId": transactionData.TradeStatusId,
            "transTypeId": transactionData.AccountIdToBalance===3?26:25,
            "transDate": transactionData.TransDate,
            "transAmount": transactionData.TransAmount,
            "localAmount": transactionData.LocalAmount,
            "transPercentage": transactionData.TransPercentage,
            "exchangeRateId": 0,
            "exchangeRate": transactionData.ExchangeRate,
            "allocationDate": "",
            "shares": 0,
            "nav": 0,
            "transDescription": transactionData.TransDescription ? transactionData.TransDescription : "",
            "initialAllocationDate": "",
            "isFullRedemption": false,
            "partialRedemptionModeId": 0,
            "isInsurance": false,
            "isFee": false,
            "isShareBased": false,
            "isCommitmentRelease": false,
            "modifiedBy": 0,
            "transactionPEDetails":peData,
            "childTrans": childtrans
        };

        if (!transactionData.TradeStatusId || transactionData.TradeStatusId === "") {
            SBNotify({ Msg: "Please Select Status ", type: "error" });
            saveSuccess = false;
        }

        else if (!transactionData.AccountIdToBalance || transactionData.AccountIdToBalance === 0) {
            SBNotify({ Msg: "To Account is Required", type: "error" });
            saveSuccess = false;
        }
       
        else if (!transactionData.AssetId || transactionData.AssetId === 0) {
            SBNotify({ Msg: "Asset is Required", type: "error" });
            saveSuccess = false;
        }
        else if (!transactionData.PortfolioId || transactionData.PortfolioId === 0) {
            SBNotify({ Msg: "Portfolio is Required", type: "error" });
            saveSuccess = false;
        }

        else if (!transactionData.TransDate) {
            SBNotify({ Msg: "Please Choose Transaction Date", type: "error" });
            saveSuccess = false;
        }
        else  if (parseFloat(parseFloat(transactionData.TransAmount).toFixed(4)) > parseFloat(parseFloat(transactionData.DistTotalPosition).toFixed(4))) {
           
            SBNotify({ Msg:'Transaction cannot be saved because Distribution Amount exceeds available balance..', type: "error" });
            saveSuccess = false;
        }
        else if (transactionData.TransPercentage>100) {
            SBNotify({ Msg: "Transaction cannot be saved because Percentage greater than 100 ", type: "error" });
            saveSuccess = false;
        }
        if (saveSuccess) {
            sbaAxios({
                url: `${insertUpdateRedemption}`,
                method: "post",
                data: savedata,
            })
                .then((response) => {
                    if (response) {
                        SBNotify({
                            type: "success",
                            Msg: "Distribution Saved Successfully",
                        });
                     navigateBack();

                    } else {
                        SBNotify({
                            type: "error",
                            Msg: `Failed to Update`,
                        });
                    }
                })
                .catch(() => { });
        }
    }

    
    const loadFeeChange = (e) => {
        const updateValue = parseFloat(e) || 0;
        const updateChildDetails = transactionData.ChildDetails;
        updateChildDetails.find(item => item.TransTypeId === 22).TransAmount = updateValue;
        setTransactionData((prevData) => ({ ...prevData, ChildDetails: updateChildDetails ,TotalDistributionAmount:Math.abs(prevData.TransAmount)-updateValue,LocalLoadFees:updateValue*prevData.ExchangeRate,TotalLocalAmount:Math.abs(prevData.LocalAmount)-(updateValue*prevData.ExchangeRate)}));
    }
    
    const handleClick = () => {
      setShowModal(true);
     
    };

    const exchangeRateChange= (e)=>
    {
        const updateChildDetails = transactionData.ChildDetails;
                  const loadfees=  updateChildDetails.find(item => item.TransTypeId === 22).TransAmount;
                    const parsedValue = parseFloat(e);
                    setTransactionData(value => ({
                        ...value,
                        ExchangeRate: parsedValue,
                        LocalAmount: transactionData?.TransAmount * parsedValue,
                        LocalLoadFees:loadfees*parsedValue,
                        TotalLocalAmount:(Math.abs(transactionData?.TransAmount)*parsedValue) -(Math.abs(loadfees)*parsedValue)
                    }));
    }
    const portfolioFilterChange = (e) => {
        const terms = e.filter.value;
        if (terms.length > 1) {
          setPortfolioByTerm(terms);
        }
     else
     setPortfolioList([]);
      };
      const getPortfolioListByTerms = async (term) => {
        try {
          const response = await sbaAxios({ url: getPortfolioListAPI + '?searchText=' + term });
          return response;
        }
        catch (e) {
          return [];
        }
      };
      const setPortfolioByTerm = async (term) => {
        try {
          const portfolioList = await getPortfolioListByTerms(term);
          setPortfolioList(portfolioList);
        }
        catch (e) {
          console.log(e, 'Error Fetching the data for portfolio');
          setPortfolioList([]);
        }
      };
      
    return (
        <>
            <TopBar label={"Transactions"} />
            <div id="AddtoPorfolio" className="mainContentData">
            <BreadCrumbs Levels={Level} />
            <div className="asset-detail-screen p-3">
            <div className="container-fluid p-3">
            <div className="detail p-4">
                <div className="col-lg-12 px-0">
                    <div className="row m-0">
                        <div class="row mb-4">
                        <div className="col-md-4">
                                <label className="mb-1 label">Status<span class="mandatory">*</span></label>
                                <div>
                                <SBADropDown
                                 className="w-75"
                                 data={statusDS}
                                 textField={"TransStatus"}
                                 valueField={"TransStatusId"}
                                 value={statusVal.TransStatus ? statusVal : statusDS[2]}
                                 onChange={statusDDChng} />
                                </div>
                            </div> 
                            
                            <div className="col-md-4">
                            <label className="mb-1 label">Portfolio<span class="mandatory">*</span></label>
                                <div>
                                                <SBAComboBox
                                                    className="w-75"
                                                    data={portfolioList}
                                                    textField={"PortfolioName"}
                                                    valueField={"PortfolioId"}
                                                    onChange={portfolioDDChng}
                                                    onFilterChange={portfolioFilterChange}
                                                    value={portfolioVal}
                                                    disabled={iseditable}
                                                />
                                </div>
</div>
<div>
                                </div>    
                        </div>

                        <div class="row mb-4">
                        <div className="col-md-4">
                        <label className="mb-1 label">Asset<span class="mandatory">*</span></label>
                                <div>
                                <SBAComboBox
                                 className="w-75"
                                 data={assetList}
                                 textField={"AssetName"}
                                 valueField={"AssetId"}
                                 value={AssetVal}
                                 onChange={(e) => AssetChng(e)}
                                 onFilterChange={AssetFilterChange}
                                 disabled={iseditable}
                                />
                                </div>
                                </div>
                                <div className="col-md-4">
                                <label className="mb-1 label">Share Class</label>
                                <div>
                                                <SBADropDown
                                                    className="w-75"
                                                    data={shareClassList}
                                                    textField={"ShareClassName"}
                                                    valueField={"ShareClassId"}
                                                    value={ShareClassVal}
                                                    onChange={(e) => ShareClassChng(e)}
                                                    disabled={iseditable}
                                                />
                                            </div>
                            </div>
                            </div>
                            <div class="row mb-4">
                            <div className="col-md-4">
                                <label className="mb-1 label">To Account<span class="mandatory">*</span></label>
                                <div>
                                    <SBAComboBox
                                        className="w-75"
                                        data={ToAccount}
                                        textField={"AssetName"}
                                        valueField={"AssetId"}
                                        value={ToAccountsVal}   
                                       onChange={ToaccountChange}
                                                   
                                    />
                                </div>
                            </div>
                            <div className="col-md-4">
                                <label className="mb-1 label">Transaction Date</label>
                                <span class="mandatory">*</span>
                                <div className="d-flex gap-2">
                                                <SBDatePicker
                                                    className="w-75"
                                                    value={moment(transactionData.TransDate)}
                                                    onChange={(e) => transdateChange(e)}
                                                />
                                </div>
                            </div>
                                </div>
                      
                                                                       
                         
                        <div class="row mb-4">
                        <div className="col-md-4">
                        <label className="mb-1 label">Recallable Amount</label>
                                            <div className="d-flex gap-2">
                                                <SBACurrencyInput
                                                    className={"form-control w-75"}

                                                    decimalsLimit={2}
                                                    value={RecallableAmount}
                                                    onBlur={(e) => {
                                                        const parsedValue = parseFloat(e);
                                                        setTransactionData(prevData => ({
                                                            ...prevData,
                                                            TransactionPEDetails: {
                                                                ...prevData.TransactionPEDetails,
                                                                RecallableAmount: parsedValue
                                                            }
                                                        }));
                                                    }}
                                                    disableGroupSeparators={false}
                                                />                       
                        </div>
                        </div>
                        <div className="col-md-4">
                        <label className="mb-1 label">% of Total Distribution</label>
                                            <div className="d-flex gap-2">
                                            <input className="form-control w-75" type="text"
                                                    disabled={!IsFIFO}
                                                  
                                                   value={transactionData?.TransPercentage}
                                                    onChange={(e) =>percentToamountCalc(e)}                                                  
                                                   
                                                />
                        </div>
                        </div>
                        </div>
                        <div class="row mb-4">
                        <div className="col-md-4">
                        <label className="mb-1 label">Recallable Percent</label>
                                            <div className="d-flex gap-2"> <SBACurrencyInput
                                                className={"form-control w-75"}

                                                decimalsLimit={2}
                                                value={Recallablepercent}
                                                onBlur={(e) => {
                                                    const parsedValue = parseFloat(e);
                                                    setTransactionData(prevData => ({
                                                        ...prevData,
                                                        TransactionPEDetails: {
                                                            ...prevData.TransactionPEDetails,
                                                            RecallablePercent: parsedValue
                                                        }
                                                    }));
                                                }}
                                                disableGroupSeparators={false}
                                            />
                     
                        </div>
                        </div>
                        <div className="col-md-4">
                                            <div> <Link className="noUnderLine" onClick={handleClick}>USD</Link></div>
                        <label className="mb-1 label">Distribution Amount</label>
                                            <div className="d-flex gap-2">
                                                <SBACurrencyInput
                                                    className={"form-control w-75"}
                                                    disabled={!IsFIFO}
                                                   // decimalsLimit={2}
                                                    value={transactionData?.TransAmount ? Math.abs(transactionData?.TransAmount) : '0.00'}
                                                    onBlur={(e) => TopercentCalc(e)}
                                                    
                                                    disableGroupSeparators={false}
                                                />

                       
                        </div>
                        </div>
                       
                        <div className="col-md-4">
                                            <div> <Link className="noUnderLine" onClick={handleClick}>{portfolio?.CurrencyCode}</Link><span style={{marginLeft:'8px'}}>({currencyFormatter(transactionData.ExchangeRate,2)})</span></div>
                        <label className="mb-1 label">Local Distribution Amount</label>
                                            <div className="d-flex gap-2">
                                                <SBACurrencyInput
                                                    className={"form-control w-75"}
                                                    disabled={true}
                                                    value={transactionData?.LocalAmount ? Math.abs(transactionData?.LocalAmount) : '0.00'}
                                                    disableGroupSeparators={false}
                                                />
                       
                        </div>
                        </div>
                            </div>
                        
                            <div class="row mb-4">
                            <div className="col-md-4">
                        <label className="mb-1 label">Interest Income</label>
                                            <div className="d-flex gap-2">
                                                <SBACurrencyInput
                                                    className={"form-control w-75"}

                                                    decimalsLimit={2}
                                                    value={InterestIncome}
                                                    onBlur={(e) => {
                                                        const parsedValue = parseFloat(e);
                                                        setTransactionData(prevData => ({
                                                            ...prevData,
                                                            TransactionPEDetails: {
                                                                ...prevData.TransactionPEDetails,
                                                                InterestIncome: parsedValue
                                                            }
                                                        }));
                                                    }}
                                                    disableGroupSeparators={false}
                                                />
                    
                        </div>
</div>
<div className="col-md-4">
                        <label className="mb-1 label"> Fees</label>
                                            <div className="d-flex gap-2">
                                                <SBACurrencyInput
                                                    className="w-75"
                                                    decimalsLimit={2}
                                                    value={Math.abs(transactionData.ChildDetails?.find(item => item.TransTypeId === 22)?.TransAmount||0)}
                                                    onBlur={(e) => {
                                                        loadFeeChange(e)
                                                    }}

                                                disableGroupSeparators={false}
                                            />
                      
                        </div>
                        </div>
                        <div className="col-md-4">
                        <label className="mb-1 label">Fees</label>
                                            <div className="d-flex gap-2">
                                                <SBACurrencyInput
                                                    className="w-75"
                                                    decimalsLimit={2}
                                                    value={Math.abs(transactionData.LocalLoadFees||0)}
                                                   disabled={true}
                                                disableGroupSeparators={false}
                                            />
                                               </div>
                        </div>
                        </div>

                        <div class="row mb-4">
                        <div className="col-md-4">
                        <label className="mb-1 label">Interest Expense</label>
                                            <div className="d-flex gap-2"> <SBACurrencyInput
                                                className={"form-control w-75"}

                                                decimalsLimit={2}
                                                value={InterestExpense}
                                                onBlur={(e) => {
                                                    const parsedValue = parseFloat(e);
                                                    setTransactionData(prevData => ({
                                                        ...prevData,
                                                        TransactionPEDetails: {
                                                            ...prevData.TransactionPEDetails,
                                                            InterestExpense: parsedValue
                                                        }
                                                    }));
                                                }}
                                                disableGroupSeparators={false}
                                            />
                        
                        </div>
                        </div>
                        <div className="col-md-4">
                        <label className="mb-1 label"> Total Distribution Amount</label>
                                            <div className="d-flex gap-2">
                                                <input className="form-control w-75" disabled={true} type="text" value={currencyFormatter(Math.abs(transactionData.TotalDistributionAmount, 2)||0)} />                            
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                        <label className="mb-1 label"> Total Local Distribution Amount</label>
                                            <div className="d-flex gap-2">
                                                <input className="form-control w-75" disabled={true} type="text" value={currencyFormatter(Math.abs(transactionData.TotalLocalAmount, 2))} />                            
                                            </div>
                                        </div>
                            </div>
                       
                     
                        <div class="row mb-4">
                        <div className="mb-4">
                                <label className="mb-1 label">  <input type="checkbox" checked={transactionData.TransactionPEDetails.IsRecallable} onChange={(e) => { const parsedValue = parseFloat(e);
                                                    setTransactionData(prevData => ({
                                                        ...prevData,
                                                        TransactionPEDetails: {
                                                            ...prevData.TransactionPEDetails,
                                                            IsRecallable: e.target.checked
                                                        }
                                                    }));}} /> Is Recallable</label>
                            </div>

                           
                            <div className="mb-4">
                                            <label className="mb-1 label">  <input type="checkbox" checked={IsFIFO} onChange={(e) => { FIFOChange(e) }}/> FIFO</label>
                            </div>

                           </div>
                        </div>
                        


                                <div class="row">
                                    <div class="col-sm-9">
                                        <div className="scrollable-table" style={{ height: "200px", overflowY: 'scroll' }}>

                                            <table
                                                class="table table-striped"
                                                id="DistributionTable"
                                                border="1"
                                            >
                                                <thead style={{ position: 'sticky', top: '0' }}>
                                                    <tr>
                                                        <th colSpan={2}>Lot</th>
                                                        <th colSpan={2}>Initial Allocation Date</th>
                                                        <th colSpan={2}>Total Position</th>
                                                        <th colSpan={2}>% to Distribute </th>
                                                        <th colSpan={2}>Amount to Distribute</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {transactionData.ChildDetails.length > 1 && transactionData.ChildDetails.map((item, parentIndex) => (
                                                     (item.TransTypeId ===26 && item.AssetId!==transactionData.AccountIdToBalance) || (item.TransTypeId ===25 && item.AssetId!==transactionData.AccountIdToBalance)?
                                                            <tr key={parentIndex}>
                                                                <td colSpan={2}>
                                                                    {item.AssetLotName}
                                                                </td>
                                                                <td colSpan={2}>
                                                                    {moment(item.InitialAllocationDate).format("MM-DD-YYYY")}
                                                                </td>
                                                                <td colSpan={2}>
                                                                    {currencyFormatter(item.TransPosition)}
                                                                </td>
                                                                <td colSpan={2}>
                                                                <input className="form-control w-75" type="text"
                                                     id={"txt_DistPercent_" + item.RowIndex + ""}
                                                    value={Math.abs(item.TransPercentage)}
                                                    disabled={IsFIFO}
                                                    onChange={(e) => GridpercentToamountCalc(e, item.RowIndex)}                                                
                                                   
                                                />
                                                                    {/* <SBACurrencyInput
                                                                        key={parentIndex + "text4"}
                                                                        value={Math.abs(item.TransPercentage)}
                                                                        id={"txt_DistPercent_" + item.RowIndex + ""}
                                                                        disabled={IsFIFO}
                                                                        onBlur={(e) => GridpercentToamountCalc(e, item.RowIndex)}
                                                                       // decimalsLimit={2}
                                                                    /> */}
                                                                </td>
                                                                <td colSpan={2}>




                                                                    <SBACurrencyInput
                                                                        key={parentIndex + "text4"}
                                                                        value={Math.abs(item.TransAmount)}
                                                                        className="form-control Distamt"
                                                                        id={"txt_DistAmount_" + item.RowIndex + ""}
                                                                        disabled={IsFIFO}
                                                                        onBlur={(e) => GridTopercentCalc(e, item.RowIndex)}
                                                                        //decimalsLimit={2}
                                                                    />

                                                                </td>

                                                            </tr> : null


                                                    ))}
                                                </tbody>
                                                <tfoot>
                                                    <tr>
                                                        <td colSpan={2} style={{ backgroundColor: "#EAF6FF", fontWeight: 'bold' }}
                                                            class="text-right">Total</td>
                                                        <td colSpan={2} style={{ backgroundColor: "#EAF6FF" }}
                                                            class="text-right"></td>
                                                        <td colSpan={2} style={{ backgroundColor: "#EAF6FF" }}
                                                            class="text-right" id="txtTransAmtTotalPosition">{currencyFormatter((transactionData?.DistTotalPosition) || 0)}</td>
                                                        <td colSpan={2} style={{ backgroundColor: "#EAF6FF", paddingLeft: "20px" }}
                                                            class="text-right" id="txtTransPercTotalPosition" >{currencyFormatter((transactionData?.DistTotalTransPercent) || 0)}</td>
                                                        <td colSpan={2} style={{ backgroundColor: "#EAF6FF", paddingLeft: "20px" }}
                                                            id="txtTransAmount">{currencyFormatter((transactionData?.DistTotalTransAmt) || 0)}
                                                        </td>
                                                    </tr>
                                                </tfoot>
                                            </table>


                                        </div>
                                    </div>
                                </div>
                                <div className="row m-0">
                                    <div className="col-md-9 mb-4">
                                        <label className="mb-1 label">Description</label>
                            <div style={{ height: 200, width: "100%" }}>
                                <textarea
                                    className="form-control"
                                    type="text"
                                    name="TransDescription"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div
                  className="m-3 d-flex justify-content-end"
                      
                  style={{ paddingBottom: "15px", paddingRight: "410px" }}
              >
             
                <button className="s-sm-btn"
                  onClick={() => { navigateBack() }}
                >
                  Cancel
                </button>
                                {transactionId !== 0 ? (
                                    <button className="ms-2 p-sm-btn"
                                        disabled={!transactionEditAccess || transactionData.IsLocked} onClick={() => { saveDistribution() }}
                                    >
                                        Save
                                    </button>
                                ): (
                                        <button className="ms-2 p-sm-btn"
                                            disabled={false} onClick={() => { saveDistribution() }}
                                        >
                                            Save
                                        </button>
                                    )}


                

              </div>
            </div>
        </div>  
     

                </div>
              

            </div>
            <ExchangeRateModal showModal={showModal} value={transactionData?.ExchangeRate} closeModal={()=>{setShowModal(false)}} onBlur={(e)=>exchangeRateChange(e)}></ExchangeRateModal>
            <ToastContainer></ToastContainer>
        </>
    );

}
const getPortfolioDetailsByID = async (portfolioId) => {
    try {
        const response = await sbaAxios({ url: getPortfolioDetailAPI + portfolioId });
        return response;
    }
    catch (e) {
        console.log(e, 'Error Fetching the portfolio details')
        return {};
    };
};
var date = new Date();
var TransactionDate = new Date(date.getFullYear(), date.getMonth() + 1, 1);




const Editable = {
    "ExchangeRate": true,
    "TotalRedemptionAmount": true,
    "RedemptionFee": true,
    "TotalPosition": true,
}

const plainDistribution = {
    "TransId": 0,
    "TransTypeId": 14,
    "TransTypeName": "Redeem to Cash",
    "PortfolioId": 0,
    "PortfolioName": "",
    "AssetId": 0,
    "AssetName": "",
    "ShareclassId": 0,
    "ShareClassName": "",
    "AssetLotId": 0,
    "AccountIdToBalance": 1,
    "AccountIdToBalanceName": "CASH",
    "AssetLotName": "",
    "TradeStatusId": 2,
    "TradeStatusName": "Executed",
    "TransDate": TransactionDate,
    "TransAmount": 0,
    "LocalAmount": 0,
    "LocalLoadFees":0,
    "TotalLocalAmount":0,
    "TotalPosition": 0,
    "TransPercentage": 0,
    "NAV": 0,
    "Distributionamt": 0,
    "TotalDistributionamtPercent":0,
    "NrOfShares": 0,
    "CurrencyId": 0,
    "CurrencyCode": "",
    "ExchangeRateId": 0,
    "ExchangeRate": 1,
    "InitialAllocationDate": null,
    "IsFullRedemption": true,
    "PartialRedemptionModeId": null,
    "IsInsurance": false,
    "IsFee": false,
    "IsCommitmentRelease": false,
    "TransDescription": "",
    "ModifiedById": 0,
    "ModifiedByName": "",
    "BalancegridTotalPosition": 0,
    "BalancegridTotalAmtToRedeem": 0,
    "BalancegridTotalPercent":0,
    "TransactionPEDetails": {
        "PETransDetailID": 1,
        "IsRecallable": false,
        "IsImpactCommitment": false,
        "RecallableAmount": 0,
        "RecallablePercent": 0,
        "InterestIncome": 0,
        "InterestExpense": 0,
    },
    "ChildDetails": [
        {
            "TransId": 0,
            "TransTypeId": 22,
            "TransTypeName": "Load Fee",
            "AssetId": 0,
            "AssetName": "",
            "ShareclassId": 0,
            "ShareClassName": "",
            "AssetLotId": 0,
            "AssetLotName": "",
            "TransDate": "",
            "TransAmount": 0,
            "InitialAllocationDate": "",
            "TotalNrOfShares": 0,
            "TotalPosition": 0,
            "TransPercentage": 0,
            "NrOfShares": 0,
            "TransDescription": "",
            "ModifiedById": 0,
            "ModifiedByName": ""
        }]
}

